import { render } from "./BuilderDemo.vue?vue&type=template&id=eca0d95e&scoped=true"
import script from "./BuilderDemo.vue?vue&type=script&lang=js"
export * from "./BuilderDemo.vue?vue&type=script&lang=js"

import "./BuilderDemo.vue?vue&type=style&index=0&id=eca0d95e&scoped=true&lang=scss"

import exportComponent from "/srv/sites/eservice.talronbatt.co.il/api/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eca0d95e"]])

export default __exports__